module.exports = __webpack_public_path__ + "img/af.e287a0c3.svg";